import { Suspense } from "react";
import { createHashRouter } from "react-router-dom";
import PublicLayout from "../../layouts/Public";
import { routes } from "./routes";
import { ScreenLoaderWhite } from "../../components/CustomComponents/ScreenLoaderWhite";

export const restrictedRouter = createHashRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: Object.entries(routes).map(([_, route]) => ({
      ...route,
      element: (
        <Suspense fallback={<ScreenLoaderWhite />}>
          <route.element />
        </Suspense>
      ),
    })),
  },
]);
